import { useEffect } from 'react'
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'
import PrivateRoute from '@/providers/private-routes'
import { useAuth } from '@/context/auth-context'

export const Route = createFileRoute('/organizations')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()
  const { user, loading } = useAuth()

  useEffect(() => {
    if (user && !loading) {
      if (!user?.profile_completed) {
        navigate({
          to: '/onboarding/profile',
        })
        return
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, loading])
  return (
    <PrivateRoute>
      <Outlet />
    </PrivateRoute>
  )
}
